<template>
  <div class="nav-menu">
    <div class="menu">
      <div class="left-sec">
        <div class="logo-img">
          <img style="height: 40px" src="/img/site_logo.png" alt="Logo" />
        </div>
        <div class="menu-box">
          <div
            v-for="(item, index) in sidebarParent"
            :key="index"
            :class="`navigate-data ${
              sidebar === item.name ? 'navigate-active' : ''
            }`"
            v-on:click="item.disable ? null : toglerData(item.name)"
          >
            <div style="justify-content: center" class="d-flex">
              <component :is="item.component"></component>
            </div>
            <p style="font-size: 9px">
              {{ item.name }}
            </p>
          </div>
        </div>
        <div class="container">
          <!-- Bagian baru yang akan ditambahkan -->
          <div class="garis">
            <div class="navigate-3">
              <div class="d-flex ml-2">
                <garis />
              </div>
            </div>
          </div>

          <!-- Bagian logout -->
          <div
            class="profile profile-margin-right flex-column"
            style="position: absolute; bottom: 10px; margin-left: 10px"
          >
            <v-row class="profile-hover">
              <div
                class="logout-box"
                @click="logout"
                style="margin-left: -10px; margin-top: 10px; padding: 5px"
              >
                <LogOutIcon
                  class="logout-icon"
                  style="width: 10px; height: 10px"
                />
                <span style="font-size: 12px">Logout</span>
              </div>
            </v-row>
            <div
              style="
                display: flex;
                align-items: center;
                gap: 20px;
                margin-top: 15px;
              "
            >
              <div
                class="profile-img"
                style="font-size: 15px; padding: 2px 0; margin-top: 5px"
              >
                AD
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-container
        v-if="isSidebarActive && sidebar != 'Beranda'"
        class="right-sec"
      >
        <div class="side-data">
          <h2>{{ sidebar }}</h2>
          <div
            class="program"
            v-for="(data, idx) in sidebarParent.find(
              (item) => item.name === sidebar
            ).submenu"
            :key="idx"
          >
            <span>{{ data.name }}</span>
            <!-- opsi menu user tulis di sini -->
            <div
              v-for="(data2, idx2) in data.children"
              :key="idx2"
              class="navigate-3 test"
              :class="{ actived: layout === data2.name }"
              @click="toglerSubMenu(data2.name, data2.path)"
            >
              <div class="navigate-item d-flex ml-2">
                <component :is="data2.component"></component>
              </div>
              <div class="ml-2" style="font-size: 15px">
                <p>{{ data2.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Home from "./icons/Home.vue";
import UserScheduleIcon from "./icons/UserScheduleIcon.vue";
import SertifikatIcon from "./icons/SertifikatIcon.vue";
import InputIcon from "./icons/InputIcon.vue";
import RiviewIcon from "./icons/RiviewIcon.vue";
import LogOutIcon from "./icons/LogOutIcon.vue";
import Garis from "./icons/Garis.vue";
import KelasLMS from "./icons/KelasLMS.vue";
import MainBanner from "./icons/MainBanner.vue";
import Event from "./icons/Event.vue";
import Voucher from "./icons/Voucher.vue";
import Class from "./icons/Class.vue";
import Section5 from "./icons/Event-section5.vue";
import Section4 from "./icons/Section4.vue";
import Section3 from "./icons/Section3.vue";
import Section2 from "./icons/Section2.vue";
import Section1 from "./icons/Section1.vue";
import Career from "./icons/Career.vue";
import CareerApplication from "./icons/CareerApplication.vue";
import Instructor from "./icons/Instructor.vue";
import UserManagement from "./icons/UserManagement.vue";
import Transaction from "./icons/Transaction.vue";
import KampusMerdeka from "./icons/KampusMerdeka.vue";
import Journal from "./icons/Journal.vue";
import Schedule from "./icons/Schedule.vue";
import Testimoni from "./icons/Testimoni.vue";
import Survey from "./icons/Survey.vue";
import Faq from "./icons/Faq.vue";
import Article from "./icons/Article.vue";
import Statistic from "./icons/Statistic.vue";
import NonUser from "./icons/NonUser.vue";
import User from "./icons/User.vue";
import Content from "./icons/Content.vue";
import Program from "./icons/Program.vue";
import Reconciliation from "./icons/Reconciliation.vue";
import HitBanner from "./icons/HitBanner.vue";
import Portfolio from "./icons/Portfolio.vue";
import CeritaAlumni from "./icons/CeritaAlumni.vue";
import Partner from "./icons/Partner.vue";
import LogoKlien from "./icons/LogoKlien.vue";
import PrivacyPolicy from "./icons/PrivacyPolicy.vue";
import LinkCircle from "./icons/link-circle.vue";
import PresentionChart from "./icons/Presention-chart.vue";
import UserSquare from "./icons/User-square.vue";
import DataB2b from "./icons/Data-B2b.vue";
export default {
  data() {
    return {
      layout: "Home",
      isHideKelasLMS: false,
      // isHideMasterData: false,
      isTransaction: false,
      isDataActive: false,
      isSidebarActive: false,
      sidebar: "Beranda",
      sidebarParent: [
        {
          name: "Beranda",
          component: Home,
          disable: false,
        },
        {
          name: "User Management",
          component: UserManagement,
          disable: false,
          submenu: [
            {
              name: "",
              children: [
                {
                  name: "Statistik",
                  component: Statistic,
                  path: "/statistic",
                },
                {
                  name: "User Aktif",
                  component: User,
                  path: "/user",
                },
                {
                  name: "User Tidak Aktif",
                  component: NonUser,
                  path: "/user-tidak-aktif",
                },
              ],
            },
          ],
        },
        {
          name: "Finance",
          component: Transaction,
          disable: false,
          submenu: [
            {
              name: "B2C",
              children: [
                {
                  name: "Public Training",
                  component: Section1,
                  path: "/transaction/b2b/public-training",
                },
                {
                  name: "Bootcamp",
                  component: Section2,
                  path: "/transaction/b2b/bootcamp",
                },
                {
                  name: "Event",
                  component: Section5,
                  path: "/transaction/b2b/event",
                },
              ],
            },
            {
              name: "B2B",
              children: [
                {
                  name: "Acceleration Digital",
                  component: Section3,
                  path: "/transaction/b2b/acceleration",
                },
              ],
            },
            {
              name: "B2G",
              children: [
                {
                  name: "Prakerja",
                  component: Section4,
                  path: "/transaction/b2g/prakerja",
                },
              ],
            },
            // {
            //   name: "LOG",
            //   children: [
            //     {
            //       name: "Transaction Log",
            //       component: Section4,
            //       path: "/transaction/log/transaction_log",
            //     },
            //   ],
            // },
          ],
        },
        {
          name: "CRM",
          component: KelasLMS,
          disable: false,
          submenu: [
            // {
            //   name: "Ringkasan",
            //   children: [
            //     {
            //       name: "Statistik",
            //       component: Statistic,
            //       path: "/crm-b2b-statistic",
            //     },
            //   ],
            // },
            {
              name: "B2C",
              children: [
                // {
                //   name: "Public Training",
                //   component: Section1,
                //   path: "/crm-event",
                // },
                // {
                //   name: "Bootcamp",
                //   component: Section2,
                //   path: "/crm-event",
                // },
                {
                  name: "Event",
                  component: Section5,
                  path: "/crm-event",
                },
                // {
                //   name: "Acceleration Digital",
                //   component: Section3,
                //   path: "/crm-akselerasi",
                // },
              ],
            },
            {
              name: "B2B",
              children: [
                
                {
                  name: "Corp Collaboration",
                  component: LinkCircle,
                  path: "/crm-b2b-collaboration",
                },
                {
                  name: "Corp Training",
                  component: PresentionChart,
                  path: "/crm-b2b-training",
                },
                {
                  name: "Talent as a Service",
                  component: UserSquare,
                  path: "/crm-b2b-talent-service",
                },
                {
                  name: "Technology Service",
                  component: DataB2b,
                  path: "/crm-b2b-service",
                },
              ],
            },
            // {
            //   name: "B2G",
            //   children: [
            //     {
            //       name: "Kartu Prakerja",
            //       component: Section4,
            //       path: "/crm-event",
            //     },
            //   ],
            // },
            {
              name: "Lainnya",
              children: [
                {
                  name: "Karir",
                  component: CareerApplication,
                  path: "/career-application",
                },
              ],
            },
          ],
        },
        {
          name: "Program Manager",
          component: Program,
          disable: false,
          submenu: [
            {
              name: "Program",
              children: [
                {
                  name: "Program Pelatihan",
                  component: Class,
                  path: "/class-category",
                },
                {
                  name: "Jadwal Tayang",
                  component: Schedule,
                  path: "/schedule",
                },
                {
                  name: "Event",
                  component: Event,
                  path: "/event-category",
                },
                {
                  name: "Mentor",
                  component: Instructor,
                  path: "/instructor",
                },
                {
                  name: "Voucher",
                  component: Voucher,
                  path: "/voucher",
                },
                {
                  name: "Kampus Merdeka",
                  component: KampusMerdeka,
                  path: "/kampus-merdeka",
                },
                {
                  name: "Karir",
                  component: Career,
                  path: "/career",
                },
              ],
            },
            {
              name: "Rapor Kelas",
              children: [
                {
                  name: "Jadwal Peserta",
                  component: UserScheduleIcon,
                  path: "/user-schedule",
                },
                {
                  name: "Penilaian",
                  component: RiviewIcon,
                  path: "/assessment-review",
                },
                {
                  name: "Sertifikat",
                  component: SertifikatIcon,
                  path: "/certificate",
                },
              ],
            },
            {
              name: "Blasting Email",
              children: [
                {
                  name: "Blasting",
                  component: Survey,
                  path: "/blast-template",
                },
              ]
            },
            {
              name: "Laporan",
              children: [
                {
                  name: "Reporting Log",
                  component: Survey,
                  path: "/reporting-log",
                },
                {
                  name: "Reconciliation",
                  component: Reconciliation,
                  path: "/reconciliation",
                },
                {
                  name: "Riwayat blast",
                  component: Reconciliation,
                  path: "/blast-history",
                },
              ],
            },
            //     {
            //       name: "Main Power",
            //       children: [

            //         {
            //           name: "List Pendaftar",
            //           component: CareerApplication,
            //           path: "/career-application",
            //         },
            //       ],
            // },
            {
              name: "Laporan",
              children: [
                {
                  name: "Reflective Journal",
                  component: Journal,
                  path: "/reflective-journal",
                },
              ],
            },
          ],
        },
        {
          name: "Content Manager",
          component: Content,
          disable: false,
          submenu: [
            {
              name: "Promosi dan Informasi",
              children: [
                {
                  name: "Hit Banner",
                  component: HitBanner,
                  path: "/hit-banner",
                },
                {
                  name: "Main Banner",
                  component: MainBanner,
                  path: "/main-banner",
                },

                // {
                //   name: "Blast Email",
                //   component: Survey,
                //   path: "/blast-email",
                // },
                // {
                //   name: "Blast Report",
                //   component: Survey,
                //   path: "/blast-report",
                // },
              ],
            },
            {
              name: "Lainnya",
              children: [
                {
                  name: "Article",
                  component: Article,
                  path: "/blog",
                },
                {
                  name: "Testimoni",
                  component: Testimoni,
                  path: "/testimoni",
                },
                {
                  name: "Survey",
                  component: Survey,
                  path: "/survey",
                },
                {
                  name: "FAQ",
                  component: Faq,
                  path: "/faq",
                },
                {
                  name: "Privacy Policy",
                  component: PrivacyPolicy,
                  path: "/privacy-policy",
                },
                {
                  name: "Partner",
                  component: Partner,
                  path: "/partner",
                },
                {
                  name: "Logo Client",
                  component: LogoKlien,
                  path: "/logo",
                },
                {
                  name: "Corporate Training",
                  component: Section1,
                  path: "/corporate-training",
                },
                {
                  name: "Project Portfolio",
                  component: Portfolio,
                  path: "/project-portfolio",
                },
                {
                  name: "Cerita Alumni",
                  component: CeritaAlumni,
                  path: "/alumni-stories",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  components: {
    DataB2b,
    PresentionChart,
    UserSquare,
    Home,
    Section1,
    Section2,
    Section3,
    Section4,
    UserManagement,
    KelasLMS,
    UserScheduleIcon,
    SertifikatIcon,
    InputIcon,
    RiviewIcon,
    Garis,
    // PresentasiPeserta,
    // Assesment,
    // Certificate,
    // MasterData,
    MainBanner,
    Event,
    Voucher,
    // Blog,
    Class,
    Career,
    CareerApplication,
    Instructor,
    // Transaction,
    KampusMerdeka,
    Journal,
    Schedule,
    Testimoni,
    Survey,
    Faq,
    Article,
    // // EventTransaction,
    // // BootcampTransaction,
    LogOutIcon,
    Statistic,
    NonUser,
    User,
    LinkCircle,
  },

  methods: {
    logout() {
      localStorage.clear(); // Membersihkan semua data yang disimpan di localStorage
      sessionStorage.clear();
      this.$router.push("/login");
    },
    async checkingRole() {
      try {
        const resp = await this.$crm_http.get("/v1/user/me");
        const role = resp.data.data.user.user_type.name;
        if (role === "VISITOR") {
          this.sidebarParent.splice(1, 5);
        } else if (role === "FINANCE") {
          this.sidebarParent.splice(1, 1);
          this.sidebarParent.splice(2);
        } else if (role === "MANAGEMENT") {
          this.sidebarParent.splice(1, 3);
        } else if (role === "MANAGEMENT_CONTENT") {
          this.sidebarParent.splice(1, 4);
        }
      } catch (error) {
        this.sidebarParent.splice(1);
      }
    },
    toglerData(data, status = null) {
      if (data === this.sidebar) {
        this.isSidebarActive = !this.isSidebarActive;
      } else {
        this.isSidebarActive = true;
        this.sidebar = data;
      }
      if (data === "Beranda") {
        this.isSidebarActive = false;

        this.layout = "Home";
        this.setLayoutSession("Home");
        this.$router.push("/home").catch(() => {});
      }

      if (status !== null) {
        this.isSidebarActive = status;
      }

      this.$emit("updateSidebar", { data, status: this.isSidebarActive });
      this.setSidebarSession(data, this.isSidebarActive);
    },

    toglerSubMenu(name, path) {
      this.layout = name;
      this.setLayoutSession(name);
      this.$router.push(path).catch(() => {});
    },
    setLayoutSession(name) {
      sessionStorage.setItem("layout", name);
    },
    getLayoutSession() {
      return sessionStorage.getItem("layout");
    },

    setSidebarSession(name, status) {
      sessionStorage.setItem("sidebar", name);
      sessionStorage.setItem("isSidebarActive", status);
      this.$forceUpdate();
    },
    getSidebarSession() {
      return sessionStorage.getItem("sidebar");
    },
    getSidebarStatusSession() {
      return sessionStorage.getItem("isSidebarActive");
    },
  },
  mounted() {
    this.layout = this.getLayoutSession() || "Home";
    const tempStatus = this.getSidebarStatusSession() || null;

    const temp = this.getSidebarSession() || "Beranda";

    this.toglerData(temp, tempStatus);
    this.checkingRole();
  },
};
</script>

<style scoped>
.profile-margin-right {
  margin-right: 20px;
}

.container {
  padding: 0 !important;
}

.program {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  gap: 1rem;
}

.program :hover p {
  opacity: 60%;
}

.program p {
  margin: 0;
  color: gray;
}

.program span {
  color: darkgray;
}

.menu-box {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  /* padding: 1 2rem; */
  margin-bottom: 1rem;
}

.navigate-1 {
  display: flex;
  margin-top: 20px;
  margin-left: 4px;
  cursor: pointer;
  align-items: center;
  padding: 5px;
}

.navigate-2 {
  display: flex;
  margin-top: 20px;
  margin-left: 15px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
}

.navigate-3 {
  display: flex;
  cursor: pointer;
  align-items: center;
  color: #acafbf;
}

.test {
  padding: 0 6px;
}
.actived p {
  color: #162ca2 !important;
}

.actived {
  color: #162ca2 !important;
  background-color: #f1f6ff !important;
  font-weight: bolder;
  padding: 10px 6px;
  border-radius: 13px;
}

.navigate-data {
  width: 100%;
  margin-top: 0.8rem;
  color: white;
  cursor: pointer;
  align-items: center;
  padding: 9px 6px;
}

.navigate-data :hover {
  opacity: 0.6;
}

.navigate-data p {
  margin: 0;
  font-size: 10px;
  text-align: center;
  padding-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  visibility: visible;
}

.nav-menu {
  height: 100%;
  /* padding: 30px 10px; */
  /* overflow-y: scroll; */
  /* overflow-x: hidden !important; */
}

.left-sec {
  width: 70px;
  padding: 0 4px;
  background: #162ca2;
}

.right-sec {
  width: 280px;
  height: 100vh;
  overflow-y: scroll;
  margin-left: 0px;
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
  scrollbar-width: none;
  /* Firefox */
}

.right-sec::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.menu {
  display: flex;
  height: 100%;
}

.actived_img {
  color: #3a4bac !important;
  background: white;
  -webkit-filter: invert(100%);
}

.profile {
  display: flex;
  gap: 15px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-weight: bolder;
  position: relative;
}

.profile-hover {
  display: none;
  cursor: pointer;
  position: absolute;
  top: -120px;
  /* Naik enam kali ke atas */
  left: 10px;
  width: 30px;
  /* Mengurangi lebar kotak */
  height: 30px;
  /* Menyesuaikan tinggi kotak */
  border-radius: 8px;
  /* Mengubah radius border */
  padding: 3px;
  /* Menambah padding */
  text-align: center;
  /* Pusatkan teks */
}

.profile-hover .logout-icon {
  width: 18px;
  /* Mengurangi ukuran ikon logout */
  height: 18px;
}

.profile-hover span {
  font-size: 8px;
  /* Mengurangi ukuran teks logout */
}

.profile-hover:hover {
  color: black;
}

.profile:hover .profile-hover {
  display: flex;
  flex-direction: column;
}

.profile-img {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #162ca2;
  font-weight: bolder;
  border-radius: 50%;
  font-size: 20px;
}

.profile-name {
  letter-spacing: 2px;
}

.navigate-active {
  border: none;
  width: 100%;
  background: #3f52b4;
  border-radius: 16px;
  padding: 9px 6px;
  color: white;
  font-weight: bolder;
}

.logo-img {
  display: flex;
  justify-content: center;
  margin-inline: 15px;
  padding-top: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid white;
}

.side-data {
  margin-top: 40px;
  margin-inline: 30px;
  margin-bottom: 30px;
}

.side-data .h2 {
  font-size: 38px;
}

.profile-hover {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: -80px;
  transform: translateY(-30%);
  width: 80%;
  border-radius: 18px;
}

.profile-hover:hover {
  color: black;
}

.profile:hover .profile-hover {
  display: flex;
}

.logout-icon {
  width: 20px;
  /* Mengubah lebar ikon */
  height: 20px;
  /* Mengubah tinggi ikon */
}

.logout-box {
  font-size: 12px;
  /* Mengubah ukuran teks Logout */
}

.profile-img {
  display: flex;
  flex-direction: row-reverse;
  /* Membalik arah baris */
  align-items: center;
  /* Pusatkan konten secara vertikal */
}

.profile-img img {
  height: 40px;
  /* Sesuaikan tinggi gambar sesuai kebutuhan */
  width: auto;
  /* Sesuaikan lebar gambar sesuai kebutuhan */
  margin-left: 10px;
  /* Beri jarak dari kiri untuk gambar */
}

.profile-name {
  color: black;
  /* Warna teks nama admin */
}

.profile {
  margin-right: 20px;
}

.logout-box {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logout-icon {
  height: 20px;
  /* Atur sesuai kebutuhan */
  margin-right: 10px;
}

.logout-box span {
  color: black;
  font-size: 16px;
  /* Atur sesuai kebutuhan */
}

.profile-hover {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: -80px;
  transform: translateY(-30%);
  width: 80%;
  border-radius: 18px;
}

.profile-hover:hover {
  color: black;
}

.profile:hover .profile-hover {
  display: flex;
}

.logout-icon {
  width: 20px;
  /* Mengubah lebar ikon */
  height: 20px;
  /* Mengubah tinggi ikon */
}

.logout-box {
  font-size: 12px;
  /* Mengubah ukuran teks Logout */
}

.profile-img {
  display: flex;
  flex-direction: row-reverse;
  /* Membalik arah baris */
  align-items: center;
  /* Pusatkan konten secara vertikal */
}

.profile-img img {
  height: 40px;
  /* Sesuaikan tinggi gambar sesuai kebutuhan */
  width: auto;
  /* Sesuaikan lebar gambar sesuai kebutuhan */
  margin-left: 10px;
  /* Beri jarak dari kiri untuk gambar */
}

.profile-name {
  color: black;
  /* Warna teks nama admin */
}

.profile {
  margin-right: 20px;
}

.logout-box {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logout-icon {
  height: 20px;
  /* Atur sesuai kebutuhan */
  margin-right: 10px;
}

.logout-box span {
  color: black;
  font-size: 16px;
  /* Atur sesuai kebutuhan */
}
</style>
